import * as Common from '@/agiles/common';

export class Word extends Common.ObjectBase {
  constructor() {
    super('Word');
    this.binders.entry = new Common.ModelBinder(WordEntry);
  }
  public key: string = '';
  public value: string = '';
  public locale: string = '';
  public get name() :string{
    return this.entry?this.entry.name: '';
  }
  public get defaultValue() :string{
    return this.entry?this.entry.defaultValue: '';
  }
  public get entryBind(): WordEntry { return this.entry;}
  public set entryBind(value:WordEntry){
      this.entry = value;
      if (this.isLoaded){
          this.key = value.key;
          this.value = value.value;
          this.locale = value.locale;
      }
  }

  public entry: WordEntry;
}

export class WordEntry extends Common.ObjectBase {
  constructor() {
    super('WordEntry');
  }
  public key: string = '';
  public defaultValue: string = '';
  public value: string = '';
  public get name(): string {
    return this.key;
  }
  public locale: string ='';
}

export class WordQuery extends Common.LoadQuery {
  constructor() {
    super('WordQuery', Word);
    this.sort = 'key';
  }
  public key:string;
}
export class WordEntryQuery extends Common.LoadQuery {
  constructor() {
    super('WordEntryQuery', WordEntry);
    this.sort = 'key';
  }
  public key:string='';
  public defaultValue:string='';  
}
export class WordEntryUpdateQuery extends Common.Query {
  constructor() {
    super('WordEntryUpdateQuery', new Common.ModelBinder(WordEntry, false));
  }  
  public entry : WordEntry;
}
export class UserWordQuery extends Common.Query {
  constructor() {
    super('UserWordQuery', new Common.ModelBinder(Word, true));
  }
}


